import { Button, Form, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  confirmOTP,
  resetStatus,
  selectAuth,
  resendOTP,
} from "../../redux/reducers/slice/auth";
import "./style.scss";
import { isRequired } from "../fields/validator";
import { useTranslation } from "react-i18next";
import ReactCodeInput from "react-code-input";
import ResendOTPModal from "../modal/resendOTPModal";
import {
  ACCESS_TOKEN,
  ROUTER_PATH,
  SIGN_UP_VALUES,
} from "../../common/constant";
import { localizeRouteKey } from "../../shared/helpers";
import { setTitlePage } from "../../utils/helper";
import { actionLoadData } from "../../redux/reducers/slice/profile";

const AuthConfirmOTP = (props: any) => {
  const { type, closeAuthModal } = props;
  const auth = useSelector(selectAuth);
  const dispatch = useDispatch();
  const [OTP, setOTP] = useState("");
  const [visible, setVisible] = useState(false);
  const signUpValuesInit = JSON.parse(
    `${sessionStorage.getItem(SIGN_UP_VALUES)}`
  );
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (type !== "MODAL") {
      setTitlePage(t("title_page_confirm_otp"));
    }
    dispatch(resetStatus());
  }, []);

  useEffect((): any => {
    if (localStorage.getItem(ACCESS_TOKEN) !== null) {
      if (type === "MODAL") {
        // dispatch(getWishesList({ offset: 0, limit: 1000 }));
        dispatch(actionLoadData());
        closeAuthModal();
      } else {
        window.location.href = localizeRouteKey(ROUTER_PATH.HOME);
      }
    }
  });

  const handleSubmit = async () => {
    await dispatch(
      await confirmOTP({
        phone_number: signUpValuesInit
          ? signUpValuesInit.phone_number_signup
          : "",
        otp_code: OTP,
        password: signUpValuesInit ? signUpValuesInit.password_signup : "",
        email: signUpValuesInit ? signUpValuesInit.email_signup : "",
      })
    );
  };

  return (
    <div>
      <div className="kd-confirm-otp-form-content center">
        <span className="kd-name-component">{t("title_screen_verify")}</span>
      </div>

      <Form
        className="kd-confirm-otp-form-content center"
        size="large"
        name="loginForm"
        onFinish={handleSubmit}>
        <Form.Item noStyle>
          <span className="message" style={{ color: "black" }}>
            {i18n
              .t("auth_confirm_otp_description")
              .replace(
                "[phone_number]",
                signUpValuesInit !== null &&
                  signUpValuesInit.phone_number_signup
              )}
          </span>
        </Form.Item>

        <Form.Item
          style={{
            border: "none",
          }}
          className="kd-confirm-otp-form-item"
          rules={[isRequired]}>
          <div className="container">
            <ReactCodeInput
              name=""
              inputMode="latin-name"
              type="number"
              fields={6}
              onChange={(e) => {
                setOTP(e);
              }}
            />
          </div>
        </Form.Item>

        <Form.Item noStyle>
          <span className="message">{!visible ? auth.message : ""}</span>

          {auth.loading ? (
            <Spin size="large" />
          ) : (
            <Button
              className="kd-confirm-otp-form-button kd-btn-primary-2"
              type="primary"
              htmlType="submit">
              {t("btn_confirm")}
            </Button>
          )}
        </Form.Item>
      </Form>

      <div className="kd-confirm-otp-form-content center mb-10">
        <a
          onClick={async () => {
            await dispatch(
              await resendOTP({
                phone_number:
                  signUpValuesInit !== null
                    ? signUpValuesInit.phone_number_signup
                    : "",
              })
            );

            setVisible(true);
          }}>
          <span style={{ color: "red" }}>{t("btn_resend_code")}</span>
        </a>
      </div>

      <ResendOTPModal
        visible={visible}
        setVisible={setVisible}
        phoneNumber={
          signUpValuesInit !== null ? signUpValuesInit.phone_number_signup : ""
        }
      />
    </div>
  );
};

export default AuthConfirmOTP;
